import * as types from "../constants/actionTypes";
import { getDeals, doDealSearch } from "../api/deals";

import { generateAsyncAction } from "./generateAsyncAction";

export const getDealsResult = request => async dispatch => {
  dispatch({ type: types.GET_DEALS_REQUEST });
  const getDealsAction = await generateAsyncAction({
    onFailAction: dealsFailed,
    onSuccessAction: dealsSuccess,
    asyncApiMethod: getDeals,
    request
  });
  return dispatch(getDealsAction);
};

// const addonsSuccess = ({ payload }) => ({
//     type: types.GET_ADDONS_SUCESS,
//     payload
// });

const dealsSuccess = ({ payload }) => dispatch => {
  //const { addonImagesLookupTable, addonsGroups } = payload;
  dispatch({
    type: types.GET_DEALS_SUCCESS,
    payload: payload
  });
};

const dealsFailed = ({ message, title }) => ({
  type: types.GET_DEALS_FAIL,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});

export const getDealDetails = deal => dispatch => {
  dispatch({
    type: types.GET_DEAL_DETAILS_SUCCESS,
    payload: deal
  });
};

// const setDealSearch = payload => dispatch => {
//   dispatch({
//     type: types.SET_SEARCH_DATA,
//     payload: payload
//   });
// };

export const getDealSearch = request => async dispatch => {
  dispatch({ type: types.GET_DEAL_SEARCH_REQUEST });
  const getDealSearchAction = await generateAsyncAction({
    onFailAction: dealSearchFailed,
    onSuccessAction: dealSearchSuccess,
    asyncApiMethod: doDealSearch,
    request
  });
  return dispatch(getDealSearchAction);
};

const dealSearchSuccess = ({ payload, request }) => dispatch => {
  dispatch({
    type: types.SET_SEARCH_DATA,
    payload: request && request.searchData
  });
  dispatch({
    type: types.GET_DEAL_SEARCH_SUCCESS,
    payload: payload
  });
};

const dealSearchFailed = ({ message, title }) => ({
  type: types.GET_DEAL_SEARCH_FAIL,
  meta: {
    globalModal: {
      message,
      title
    }
  }
});

export const resetDealSearchResult = () => dispatch => {
  return dispatch({
    type: types.GET_DEAL_SEARCH_RESET
  });
};

export const getRoomResultsForDeals = payload => dispatch => {
  dispatch({
    type: types.GET_ROOM_RESULTS_DEALS_REQUEST,
    payload: payload
  });
};

export const resetDealMode = payload => dispatch => {
  dispatch({
    type: types.RESET_ROOM_RESULTS_DEALS_REQUEST,
    payload: payload
  });
};

export const dealRateUnSelected = payload => dispatch => {
  dispatch({
    type: types.DEAL_RATE_UNSELECTED,
    payload: payload
  });
  //add 1 to availability
  //remove
};

export const dealRateSelected = payload => dispatch => {
  dispatch({
    type: types.DEAL_RATE_SELECTED,
    payload: payload
  });
};

export const dealStartAnimation = payload => dispatch => {
  dispatch({
    type: types.DEAL_ANIMATION_START,
    payload: payload
  });
};

export const dealEndAnimation = payload => dispatch => {
  dispatch({
    type: types.DEAL_ANIMATION_END,
    payload: payload
  });
};

export const resetSelectedDeal = () => ({
  type: types.RESET_SELECTED_DEAL
});



// WEBPACK FOOTER //
// ./src/actions/dealsActions.js